import React, { useEffect, useState } from "react"
import "./styles.scss"
import TermsEn from "./TermsEn"
import TermsKo from "./TermsKo"
import TermsTh from "./TermsTh"
import useGetTermsDate from "./hooks/useGetTermsDate"

export default function TermsService() {
    const [lang, setLang] = useState("ko")
    const [theme, setTheme] = useState("dark")

    const [selectedDate, setSelectedDate] = useState("")
    const { optionDates, latestDate } = useGetTermsDate({ lang })

    //   MEMO(Philip): 가장 최신의 Policy를 기본으로 선택합니다.
    useEffect(() => {
        setSelectedDate(latestDate)
    }, [latestDate])

    useEffect(() => {
        const uri = new URL(window.location)
        const lang = uri.searchParams.get("lang")
        if (lang) setLang(lang)
        const theme = uri.searchParams.get("theme")
        if (theme && theme === "dark") {
            setTheme("dark")
        } else {
            setTheme("white")
        }
    }, [])

    const handleChangeSelect = (e) => {
        setSelectedDate(e.target.value)
    }

    return (
        <div className="terms-container">
            {lang !== "th" && (
                <>
                    <div className="date-box">
                        <span>Date: </span>
                        <select name="optionDate" onChange={handleChangeSelect} value={selectedDate}>
                            {optionDates.map((date) => (
                                <option key={date} value={date}>
                                    {date}
                                </option>
                            ))}
                        </select>
                    </div>
                </>
            )}
            {lang === "ko" ? (
                <TermsKo theme={theme} date={selectedDate} />
            ) : lang === "th" ? (
                <TermsTh theme={theme} date={selectedDate} />
            ) : (
                <TermsEn theme={theme} date={selectedDate} />
            )}
        </div>
    )
}
